import classNames from 'classnames';
import React from 'react';
import type { ScrollbarProps } from 'react-custom-scrollbars-2';
import CustomScrollbars from 'react-custom-scrollbars-2';
import type { ReactChildren } from 'types/utility';
import styles from './index.module.scss';

interface Props extends ScrollbarProps {
  children: ReactChildren;
  variant?: 'timeline';
}

const renderTrackHorizontal = ({ style, ...props }: any) => (
  <div
    className={styles.trackScroll}
    {...props}
    style={{
      right: 5,
      bottom: 5,
      height: 10,
      left: 5,
      borderRadius: 10,
      ...style,
    }}
  />
);

const renderTrackVertical = ({ style, ...props }: any) => (
  <div
    className={styles.trackScroll}
    {...props}
    style={{
      right: 5,
      top: 5,
      bottom: 5,
      borderRadius: 10,
      ...style,
    }}
  />
);

export type RefType = CustomScrollbars;
export const Scrollbars = React.forwardRef<CustomScrollbars, Props>((props: Props, ref) => {
  const { variant, ...rest } = props;
  const scrollbarClass = classNames(styles.scrollbarContainer, props.className, {
    [styles.innerShadow]: variant === 'timeline',
  });

  return (
    <CustomScrollbars
      ref={ref}
      className={scrollbarClass}
      hideTracksWhenNotNeeded
      renderTrackHorizontal={renderTrackHorizontal}
      renderTrackVertical={renderTrackVertical}
      {...rest}
    >
      {props.children}
    </CustomScrollbars>
  );
});

export interface ScrollbarsRefType extends RefType {
  view?: HTMLDivElement;
}
